type ChannelType =
  | "phone_call"
  | "sms"
  | "email"
  | "letter"
  | "webchat"
  | "webchat_offline"
  | "payment_plan"
  | "payment"
  | "account_update"
  | "contact_us"
  | "dispute"
  | "user_activity"
  | "trigger"
  | "comment"
  | "credit_report"
  | "reminder"
  | "credit"
  | "debit"
  | "channel_preferences_update"
  | "contact_details_update"
  | "flag_update"
  | "statute_of_limitation_update"
  | "consumer_details_update"
  | "representation_update"
  | "document_request"
  | "partner_action"
  | "legal_collections"
  | "creditor_recall_update"
  | "whatsapp"
  | "dsc";

type EventType =
  | "PHONE_CALL_INCOMING"
  | "PHONE_CALL_MISSED_INCOMING"
  | "PHONE_CALL_DIALED"
  | "PHONE_CALL_ANSWERED"
  | "SCHEDULED_PHONE_CALL"
  | "SMS_RECEIVED"
  | "SMS_SENT"
  | "SMS_DELIVERED"
  | "SMS_UNDELIVERED"
  | "SMS_LINK_CLICK"
  | "SMS_PAGE_CLICK"
  | "SMS_OPT_OUT"
  | "SMS_QUEUED"
  | "SCHEDULED_SMS"
  | "EMAIL_RECEIVED"
  | "EMAIL_SENT"
  | "EMAIL_DELIVERED"
  | "EMAIL_OPEN"
  | "EMAIL_CLICK"
  | "EMAIL_UNSUBSCRIBE"
  | "EMAIL_ATTEMPTED"
  | "EMAIL_SUPPRESSED"
  | "SCHEDULED_EMAIL"
  | "LETTER_SENT"
  | "LETTER_PROBABLY_DELIVERED"
  | "LETTER_RETURNED"
  | "WEBCHAT_CHAT"
  | "WEBCHAT_OFFLINE"
  | "PAYMENT_PLAN_SELECTED"
  | "PAYMENT_PLAN_RESCHEDULED"
  | "PAYMENT_PLAN_DEACTIVATED"
  | "PAYMENT_RECEIVED"
  | "PAYMENT_FAILED"
  | "PAYMENT_SUBMITTED"
  | "PAYMENT_FAILED_RETRY"
  | "PAYMENT_PENDING"
  | "PAYMENT_CHARGEBACK"
  | "PAYMENT_REFUND"
  | "PAYMENT_VOID"
  | "PAYMENT_RETURNED"
  | "PAYMENT_REFUND_IN_PROGRESS"
  | "PAYMENT_REFUND_FAILED"
  | "ACCOUNT_UPDATE_ADD"
  | "ACCOUNT_UPDATE_DELETE"
  | "ACCOUNT_UPDATE"
  | "CONTACT_US"
  | "DISPUTE_FILED"
  | "VERIFICATION_REQUEST_FILED"
  | "USER_POSTPONED_CREDIT_REPORT"
  | "USER_VISIT_PAYMENT_PLAN_SUMMARY"
  | "USER_VISIT_PAYMENT_PLANS"
  | "USER_SUBMITTED_QUESTIONNAIRE"
  | "COLLECTION_NOTICE_TRIGGER"
  | "UNKNOWN"
  | "INSTALLMENT_DUE_DATE_UPDATED"
  | "INSTALLMENT_SKIPPED"
  | "COMMENT"
  | "LOG_IN"
  | "VALIDATION_IN_APP"
  | "CREDIT_REPORT"
  | "REMINDER_SHOWED"
  | "REMINDER_QUEUED"
  | "CREDIT"
  | "CREDIT_REVERSED"
  | "DEBIT"
  | "CHANNEL_PREFERENCES_CHANGE"
  | "CONTACT_DETAILS_UPDATE"
  | "FLAG_UPDATE"
  | "CREDITOR_RECALL_UPDATE"
  | "STATUTE_OF_LIMITATION_UPDATE"
  | "CONSUMER_DETAILS_UPDATE"
  | "REPRESENTATION_UPDATE"
  | "DOCUMENT_REQUEST_CREATED"
  | "DOCUMENT_REQUEST_COMPLETED"
  | "PARTNER_PAYMENT_SUBMITTED"
  | "PARTNER_CREDITOR_RECALLED"
  | "CREDITOR_ADJUSTMENT"
  | "LEGAL_PRE_LEGAL"
  | "LEGAL_PLACEMENT_TO_VENDOR"
  | "LEGAL_PLACEMENT"
  | "LEGAL_JUDGMENT"
  | "LEGAL_REVERTED"
  | "LEGAL_CLOSED"
  | "LEGAL_SUIT"
  | "AFFIDAVIT_GENERATED_AND_REVIEWED"
  | "NY_AFFIRMATION_OF_SALE_GENERATED_AND_REVIEWED"
  | "VOICE_AI_CALL"
  | "WHATSAPP_SENT"
  | "WHATSAPP_DELIVERED"
  | "WHATSAPP_READ"
  | "WHATSAPP_FAILED"
  | "WHATSAPP_RECEIVED"
  | "WHATSAPP_LINK_CLICK"
  | "WHATSAPP_PAGE_CLICK"
  | "WHATSAPP_OPT_OUT"
  | "DSC_OFFER_GENERATED";

enum AccountUpdateAction {
  ADD = "add",
  DELETE = "delete",
  UPDATE = "update",
}

enum CommunicationDirection {
  OUTBOUND = "OUTBOUND",
  INBOUND = "INBOUND",
}

enum CommunicateBy {
  AGENT = "Agent",
  USER = "User",
  SYSTEM = "System",
}

export type {ChannelType, EventType};
export {AccountUpdateAction, CommunicationDirection, CommunicateBy};
